import React, { useState, useEffect } from 'react'
import Header from '../../layouts/Header';
import { Col, Container, Row, Card, Badge, Button, Accordion, Modal, Form, Alert, Pagination } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import axiosInstance from '../../api/axios';import { toast } from 'react-toastify';

const FoodRequest = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { email } = useSelector((state) => state.login);
    const [foodAccess, setFoodAccess] = useState([]);

    console.log("Access :", access);
    console.log("System Email :", email);

    useEffect(() => {
        if (Array.isArray(access)) {
            const filteredAccess = access?.filter((perm) =>
                perm?.startsWith("FoodRequest:")
            );
            setFoodAccess(filteredAccess);
        }
    }, [access]);

    console.log("Food Access:", foodAccess);

    const [foodRequests, setFoodRequests] = useState([]);
    const [filteredFoodRequests, setFilteredFoodRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [formData, setFormData] = useState({
        expectedDeliveryDate: '',
        approvedBy: ''
    });
    const [updating, setUpdating] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: '', type: '' });

    // Pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    const accessToken = localStorage.getItem("authToken");

    const getFoodRequests = async (page = currentPage, limit = recordsPerPage) => {
        try {
            setLoading(true);
            const headers = { Authorization: `Bearer ${accessToken}` };
            const response = await axiosInstance.get(`material-request-indent/approved?page=${page}&limit=${limit}`, { headers });
            console.log("Response of Food Req :", response?.data?.data);

            let foodRequests = response?.data?.data?.filter((fil) => fil?.outlet?.foodUnitId?.email === email);
            console.log("Food request :", foodRequests);

            // Filter out requests that don't have FOOD purchase unit items and exclude rejected items
            const requestsWithFoodItems = foodRequests.filter(request =>
                request?.items?.some(item =>
                    item?.rawMaterial?.purchaseUnit === 'FOOD' &&
                    item?.status !== 'REJECTED' // Exclude rejected items
                )
            );

            // Sort requests in descending order (latest first)
            const sortedRequests = requestsWithFoodItems.sort((a, b) =>
                new Date(b.createdAt) - new Date(a.createdAt)
            );

            setFoodRequests(sortedRequests || []);
            setFilteredFoodRequests(sortedRequests || []);

            // Set pagination data from API response
            if (response?.data?.pagination) {
                setTotalPages(response.data.pagination.totalPages || 1);
                setTotalRecords(response.data.pagination.totalRecords || 0);
            } else {
                // Fallback if pagination data is not available
                setTotalPages(Math.ceil(sortedRequests.length / limit));
                setTotalRecords(sortedRequests.length);
            }

        } catch (error) {
            console.log("Error in Food :", error);
            showAlert('Error fetching requests', 'danger');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getFoodRequests();
    }, []);

    // Fetch data when page or limit changes
    useEffect(() => {
        if (currentPage > 0 && recordsPerPage > 0) {
            getFoodRequests(currentPage, recordsPerPage);
        }
    }, [currentPage, recordsPerPage]);

    const showAlert = (message, type) => {
        setAlert({ show: true, message, type });
        setTimeout(() => setAlert({ show: false, message: '', type: '' }), 5000);
    };

    const handleEditClick = (request, item) => {
        setSelectedRequest(request);
        setSelectedItem(item);
        setFormData({
            expectedDeliveryDate: item.expectedDeliveryDate ? new Date(item.expectedDeliveryDate).toISOString().split('T')[0] : '',
            approvedBy: item.approvedBy || ''
        });
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedItem(null);
        setSelectedRequest(null);
        setFormData({ expectedDeliveryDate: '', approvedBy: '' });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const updateExpectedDeliveryDate = async () => {
        if (!formData.expectedDeliveryDate || !formData.approvedBy) {
            showAlert('Please fill all required fields', 'warning');
            return;
        }

        try {
            setUpdating(true);
            const headers = { Authorization: `Bearer ${accessToken}` };

            const payload = {
                _id: selectedRequest._id,
                rawMaterialId: selectedItem.rawMaterial._id,
                approvedBy: formData.approvedBy,
                expectedDeliveryDate: formData.expectedDeliveryDate
            };

            console.log("Update payload:", payload);

            const response = await axiosInstance.put('material-request-indent/update-expected-delivery-date', payload, { headers });

            console.log("Update response:", response.data);

            // Update local state
            const updatedRequests = foodRequests.map(request => {
                if (request._id === selectedRequest._id) {
                    const updatedItems = request.items.map(item => {
                        if (item.rawMaterial._id === selectedItem.rawMaterial._id) {
                            return {
                                ...item,
                                expectedDeliveryDate: formData.expectedDeliveryDate,
                                approvedBy: formData.approvedBy
                            };
                        }
                        return item;
                    });
                    return { ...request, items: updatedItems };
                }
                return request;
            });

            setFoodRequests(updatedRequests);

            // Also update filtered requests
            const updatedFilteredRequests = updatedRequests.filter(request =>
                request?.items?.some(item =>
                    item?.rawMaterial?.purchaseUnit === 'FOOD' &&
                    item?.status !== 'REJECTED'
                )
            );
            setFilteredFoodRequests(updatedFilteredRequests);
            toast.success("Delivery updated successfully", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
            handleCloseModal();
        } catch (error) {
            console.log("Error updating delivery date:", error);
            let errorMessage = '';
            if (error.response?.status === 406) {
                errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error
            }
            else if (error.response?.status === 412) {
                errorMessage = error?.response?.data?.data?.message;
            } else if (error.response?.status === 400) {
                errorMessage = error?.response?.data?.error;
            } else if (error.response?.status === 500) {
                errorMessage = error?.response?.data?.message;
            } else if (error.response?.status === 502) {
                errorMessage = error?.response?.data?.error
            }

            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } finally {
            setUpdating(false);
        }
    };

    const getStatusVariant = (status) => {
        switch (status) {
            case 'COMPLETED': return 'success';
            case 'REJECTED': return 'danger';
            case 'PENDING': return 'warning';
            case 'APPROVED': return 'primary';
            default: return 'secondary';
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Not set';
        return new Date(dateString).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const getTotalItems = (items) => {
        return items.reduce((total, item) => total + item.requestedQuantity, 0);
    };

    const getCompletedItems = (items) => {
        return items.filter(item => item.status === 'COMPLETED').length;
    };

    const canEditItem = (item) => {
        // Allow editing only for pending/approved items, not for rejected or completed
        return item.status === 'APPROVED' || item.status === 'PENDING' || !item.status;
    };

    // Filter out rejected items for display
    const getNonRejectedFoodItems = (items) => {
        return items.filter(item =>
            item?.rawMaterial?.purchaseUnit === 'FOOD' &&
            item?.status !== 'REJECTED'
        );
    };

    // Pagination handlers
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleRecordsPerPageChange = (e) => {
        const newLimit = parseInt(e.target.value);
        setRecordsPerPage(newLimit);
        setCurrentPage(1); // Reset to first page when changing records per page
    };

    // Generate pagination items
    const renderPaginationItems = () => {
        let items = [];
        const maxVisiblePages = 5;

        // Previous button
        items.push(
            <Pagination.Prev
                key="prev"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
            />
        );

        // Calculate start and end page numbers
        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        // Adjust start page if we're near the end
        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        // First page and ellipsis if needed
        if (startPage > 1) {
            items.push(
                <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
                    1
                </Pagination.Item>
            );
            if (startPage > 2) {
                items.push(<Pagination.Ellipsis key="start-ellipsis" />);
            }
        }

        // Page numbers
        for (let page = startPage; page <= endPage; page++) {
            items.push(
                <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => handlePageChange(page)}
                >
                    {page}
                </Pagination.Item>
            );
        }

        // Last page and ellipsis if needed
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                items.push(<Pagination.Ellipsis key="end-ellipsis" />);
            }
            items.push(
                <Pagination.Item key={totalPages} onClick={() => handlePageChange(totalPages)}>
                    {totalPages}
                </Pagination.Item>
            );
        }

        // Next button
        items.push(
            <Pagination.Next
                key="next"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
            />
        );

        return items;
    };

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className={`main main-app p-3 p-lg-4 ${skin === 'dark' ? 'bg-dark text-light' : 'bg-light'}`}>
                <Container className='bg-white' fluid>
                    {/* Alert */}
                    {alert.show && (
                        <Row className="mb-3">
                            <Col>
                                <Alert variant={alert.type} dismissible onClose={() => setAlert({ show: false, message: '', type: '' })}>
                                    {alert.message}
                                </Alert>
                            </Col>
                        </Row>
                    )}

                    {/* Header Section */}
                    <Row className="mb-1">
                        <Col>
                            <div className="d-flex justify-content-between align-items-center bg-white p-2">
                                <div>
                                    <h4 className="fw-bold mb-1">FOOD REQUESTS</h4>
                                    <p className="text-muted mb-0">Manage approved material requests from outlets</p>
                                </div>
                                <Button
                                    variant="outline-primary"
                                    onClick={() => getFoodRequests()}
                                    disabled={loading}
                                    size="sm"
                                >
                                    {loading ? 'Refreshing...' : 'Refresh Data'}
                                </Button>
                            </div>
                        </Col>
                        <hr />
                    </Row>

                    {/* Records Per Page Selector */}
                    {!loading && filteredFoodRequests.length > 0 && (
                        <Row className="mb-3">
                            <Col className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <span className="me-2 text-muted">Show:</span>
                                    <Form.Select
                                        size="sm"
                                        style={{ width: '80px' }}
                                        value={recordsPerPage}
                                        onChange={handleRecordsPerPageChange}
                                    >
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                        <option value="150">150</option>
                                    </Form.Select>
                                    <span className="ms-2 text-muted">records per page</span>
                                </div>

                                <div className="text-muted">
                                    Showing {(currentPage - 1) * recordsPerPage + 1} to{' '}
                                    {Math.min(currentPage * recordsPerPage, totalRecords)} of{' '}
                                    {totalRecords} records
                                </div>
                            </Col>
                        </Row>
                    )}

                    {/* Loading State */}
                    {loading && (
                        <Row className="mb-4">
                            <Col>
                                <Card className="text-center py-4 mb-4">
                                    <Card.Body>
                                        <div className="spinner-border text-primary mb-3" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mb-0">Loading approved requests...</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}

                    {/* Empty State */}
                    {!loading && filteredFoodRequests.length === 0 && (
                        <Row>
                            <Col>
                                <Card className="text-center py-5">
                                    <Card.Body>
                                        <div className="mb-3">
                                            <i className="fas fa-inbox fa-3x text-muted"></i>
                                        </div>
                                        <h5>No Approved Food Requests</h5>
                                        <p className="text-muted">There are no approved food requests with FOOD purchase items at the moment.</p>
                                        <Button variant="primary" onClick={getFoodRequests}>
                                            Check Again
                                        </Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    )}

                    {/* Requests List */}
                    {!loading && filteredFoodRequests.length > 0 && (
                        <>
                            <Row>
                                <Col>
                                    <div className="mb-3">
                                        <h6 className="text-muted">
                                            Showing {filteredFoodRequests.length} approved food request{filteredFoodRequests.length !== 1 ? 's' : ''}
                                            {' '}on page {currentPage} of {totalPages}
                                        </h6>
                                    </div>

                                    <Accordion flush>
                                        {filteredFoodRequests.map((request, index) => {
                                            const nonRejectedFoodItems = getNonRejectedFoodItems(request.items);

                                            if (nonRejectedFoodItems.length === 0) {
                                                return null; // Skip rendering if no non-rejected food items
                                            }

                                            return (
                                                <Accordion.Item
                                                    key={request._id}
                                                    eventKey={index.toString()}
                                                    className="mb-3 border rounded-3"
                                                >
                                                    <Accordion.Header>
                                                        <div className="d-flex justify-content-between align-items-center w-100 me-3">
                                                            <div className="d-flex align-items-center">
                                                                <div className="me-3">
                                                                    <Badge
                                                                        bg={skin === 'dark' ? 'light' : 'success'}
                                                                        text={skin === 'dark' ? 'dark' : 'light'}
                                                                        className="fs-6"
                                                                    >
                                                                        {request.indentNumber}
                                                                    </Badge>
                                                                </div>
                                                                <div>
                                                                    <div className="fw-semibold">
                                                                        Financial Year: {request.fin_year}
                                                                    </div>
                                                                    <small className="text-muted">
                                                                        Created: {formatDate(request.createdAt)}
                                                                    </small>
                                                                </div>
                                                            </div>
                                                            <div className="text-end">
                                                                <Badge bg={getStatusVariant(request.status)} className="mb-1">
                                                                    {request.status}
                                                                </Badge>
                                                                <div>
                                                                    <small className="text-muted">
                                                                        {nonRejectedFoodItems.length} food item{nonRejectedFoodItems.length !== 1 ? 's' : ''}
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>

                                                    <Accordion.Body>
                                                        {/* Request Summary */}
                                                        <Row className="mb-3">
                                                            <Col md={6}>
                                                                <div className="d-flex mb-2">
                                                                    <span className="text-muted me-2">Outlet:</span>
                                                                    <strong>{request?.outlet?.name}</strong>
                                                                </div>
                                                                {/* Removed Last Updated field */}
                                                            </Col>
                                                            <Col md={6}>
                                                                <div className="d-flex mb-2">
                                                                    <span className="text-muted me-2">Total Quantity:</span>
                                                                    <strong>{getTotalItems(nonRejectedFoodItems)} units</strong>
                                                                </div>
                                                                <div className="d-flex">
                                                                    <span className="text-muted me-2">Completed Items:</span>
                                                                    <strong>{getCompletedItems(nonRejectedFoodItems)} of {nonRejectedFoodItems.length}</strong>
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        {/* Items List */}
                                                        <div className="border-top pt-3">
                                                            <h6 className="mb-3">Food Requested Items</h6>
                                                            <Row>
                                                                {nonRejectedFoodItems.map((item) => (
                                                                    <Col md={6} lg={4} key={item._id} className="mb-3">
                                                                        <Card
                                                                            className={`h-100 border ${item.status === 'COMPLETED' ? 'border-success' :
                                                                                item.status === 'REJECTED' ? 'border-danger' : 'border-warning'
                                                                                }`}
                                                                        >
                                                                            <Card.Body className="p-3">
                                                                                <div className="d-flex justify-content-between align-items-start mb-2">
                                                                                    <h6 className="card-title mb-0">
                                                                                        {item.rawMaterial.name}
                                                                                    </h6>
                                                                                    <Badge bg={getStatusVariant(item.status)} size="sm">
                                                                                        {item.status}
                                                                                    </Badge>
                                                                                </div>

                                                                                <p className="small text-muted mb-2">
                                                                                    {item.rawMaterial.description}
                                                                                </p>

                                                                                <div className="d-flex justify-content-between text-sm mb-2">
                                                                                    <div>
                                                                                        <span className="text-muted">Requested:</span>
                                                                                        <br />
                                                                                        <strong>{item.requestedQuantity} {item.rawMaterial.unit}</strong>
                                                                                    </div>
                                                                                    <div>
                                                                                        <span className="text-muted">Received:</span>
                                                                                        <br />
                                                                                        <strong>{item.recievedQuantity} {item.rawMaterial.unit}</strong>
                                                                                    </div>
                                                                                </div>

                                                                                {/* Expected Delivery Date & Approved By */}
                                                                                <div className="border-top pt-2 mt-2">
                                                                                    <div className="small">
                                                                                        <div className="d-flex justify-content-between">
                                                                                            <span className="text-muted">Expected Delivery:</span>
                                                                                            <strong>{formatDate(item.expectedDeliveryDate)}</strong>
                                                                                        </div>
                                                                                        <div className="d-flex justify-content-between">
                                                                                            <span className="text-muted">Approved By:</span>
                                                                                            <strong>{item.approvedBy || 'Not set'}</strong>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                {item.remark && (
                                                                                    <div className="mt-2">
                                                                                        <small className="text-muted">Remark: </small>
                                                                                        <small>{item.remark}</small>
                                                                                    </div>
                                                                                )}

                                                                                {item?.expectedDeliveryDate &&
                                                                                            <span
                                                                                                className="fw-semibold px-2 py-1 mt-2 rounded-pill bg-primary bg-opacity-10 text-primary d-inline-block"
                                                                                                style={{ fontSize: "10px" }}
                                                                                            >
                                                                                                Delivery date has already been set and cannot be modified.
                                                                                            </span>
                                                                                        }

                                                                                {/* Edit Button */}
                                                                                {canEditItem(item) && (
                                                                                    <div className="mt-2 text-end">
                                                                                        <Button
                                                                                            variant="outline-primary"
                                                                                            size="sm"
                                                                                            onClick={() => handleEditClick(request, item)}
                                                                                            disabled={item?.expectedDeliveryDate}
                                                                                        >
                                                                                            <i className="fas fa-edit me-1"></i>
                                                                                            Update Delivery
                                                                                        </Button>
                                                                                    </div>
                                                                                )}
                                                                            </Card.Body>
                                                                        </Card>
                                                                    </Col>
                                                                ))}
                                                            </Row>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            );
                                        })}
                                    </Accordion>
                                </Col>
                            </Row>

                            {/* Pagination */}
                            {totalPages > 1 && (
                                <Row className="mt-4">
                                    <Col className="d-flex justify-content-center">
                                        <Pagination>
                                            {renderPaginationItems()}
                                        </Pagination>
                                    </Col>
                                </Row>
                            )}
                        </>
                    )}

                    {/* Edit Modal */}
                    <Modal show={showModal} onHide={handleCloseModal} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Update Delivery Date</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedItem && (
                                <div className="mb-3">
                                    <h6 className="fw-bold">{selectedItem.rawMaterial.name}</h6>
                                    <p className="text-muted small mb-3">
                                        Requested: {selectedItem.requestedQuantity} {selectedItem.rawMaterial.unit}
                                    </p>

                                    <Form>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Expected Delivery Date <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="expectedDeliveryDate"
                                                value={formData.expectedDeliveryDate}
                                                onChange={handleInputChange}
                                                min={new Date().toISOString().split('T')[0]}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Approved By <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="approvedBy"
                                                value={formData.approvedBy}
                                                onChange={handleInputChange}
                                                placeholder="Enter approver name"
                                                maxLength={50}
                                            />
                                        </Form.Group>
                                    </Form>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Cancel
                            </Button>
                            <Button
                                variant="primary"
                                onClick={updateExpectedDeliveryDate}
                                disabled={updating || formData.expectedDeliveryDate || !formData.approvedBy}
                            >
                                {updating ? 'Updating...' : 'Update Delivery Date'}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default FoodRequest;